import { State } from '../../types';

export const rhodeIsland: State = {
  name: 'Rhode Island',
  abbreviation: 'RI',
  terms: [
    {
      word: 'Aquidneck',
      phonetic: 'uh-KWID-neck',
      // audioUrl: '/audio/aquidneck.mp3',
      description: 'The island home to Newport, Middletown, and Portsmouth; the middle syllable rhymes with "squid."'
    },
    {
      word: 'Canonchet',
      phonetic: 'cuh-NON-chet',
      // audioUrl: '/audio/canonchet.mp3',
      description: 'A rural area of Hopkinton; stress is on the second syllable.'
    },
    {
      word: 'Conanicut',
      phonetic: 'ko-NAN-eh-kut',
      // audioUrl: '/audio/conanicut.mp3',
      description: 'The island on which the town of Jamestown is located.'
    },
    {
      word: 'Cowesett',
      phonetic: 'ko-WEE-set',
      // audioUrl: '/audio/cowesett.mp3',
      description: 'A neighborhood in Warwick; pronounced without a "cow" sound.'
    },
    {
      word: 'Escoheag',
      phonetic: 'ES-ko-hog',
      // audioUrl: '/audio/escoheag.mp3',
      description: 'A rural part of Exeter; some pronounce it "ES-ko-heag" with a long "e" in the final syllable.'
    },
    {
      word: 'Kickemuit',
      phonetic: 'kick-eh-MEW-it',
      // audioUrl: '/audio/kickemuit.mp3',
      description: 'A river flowing through Warren and Bristol; the second-to-last syllable rhymes with "new."'
    },
    {
      word: 'Matunuck',
      phonetic: 'muh-TOO-nick',
      // audioUrl: '/audio/matunuck.mp3',
      description: 'A village in South Kingstown; the first "u" is long, the second is short.'
    },
    {
      word: 'Miantonomi',
      phonetic: 'MY-ann-toe-no-me',
      // audioUrl: '/audio/miantonomi.mp3',
      description: 'A park and street in Newport; stress is on the first syllable.'
    },
    {
      word: 'Misquamicut',
      phonetic: 'MISS-kwahm-eh-kut',
      // audioUrl: '/audio/misquamicut.mp3',
      description: 'A beach and surrounding area in Westerly.'
    },
    {
      word: 'Moshassuck',
      phonetic: 'mo-SHAS-uck',
      // audioUrl: '/audio/moshassuck.mp3',
      description: 'One of the two rivers that converge in downtown Providence.'
    },
    {
      word: 'Narragansett',
      phonetic: 'nair-uh-GAN-sit',
      // audioUrl: '/audio/narragansett.mp3',
      description: 'A town and bay in Rhode Island; name derived from the Narragansett people.'
    },
    {
      word: 'Pascoag',
      phonetic: 'PASS-ko-ag',
      // audioUrl: '/audio/pascoag.mp3',
      description: 'A village in Burrillville; name means "the dividing place" in Nipmuck.'
    },
    {
      word: 'Pawtucket',
      phonetic: 'paw-TUCK-it',
      // audioUrl: '/audio/pawtucket.mp3',
      description: 'A city in Providence County; name means "at the falls in the river" in Narragansett.'
    },
    {
      word: 'Quonochontaug',
      phonetic: 'kwon-uh-KON-tawg',
      // audioUrl: '/audio/quonochontaug.mp3',
      description: 'A village in Charlestown; name means "home of the blackfish" in Narragansett.'
    },
    {
      word: 'Scituate',
      phonetic: 'SIT-chew-it',
      // audioUrl: '/audio/scituate.mp3',
      description: 'A town in Providence County; name means "at the cold spring/brook" in Wampanoag.'
    },
    {
      word: 'Usquepaugh',
      phonetic: 'US-kwee-paw',
      // audioUrl: '/audio/usquepaugh.mp3',
      description: 'A village in South Kingstown; name means "at the end of the pond" in Narragansett.'
    },
    {
      word: 'Weekapaug',
      phonetic: 'WEEK-uh-pawg',
      // audioUrl: '/audio/weekapaug.mp3',
      description: 'A beachfront community; name means "at the end of the pond" in Narragansett.'
    },
    {
      word: 'Woonsocket',
      phonetic: 'woon-SOCK-it',
      // audioUrl: '/audio/woonsocket.mp3',
      description: 'A city in Providence County; name means "place of steep descent" in Nipmuck.'
    }
  ]
};